export const arrowDown = {
  name: "arrow-down" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 20.9a.9.9 0 0 1-.636-.264l-5.5-5.5a.9.9 0 1 1 1.272-1.272l3.964 3.963V4a.9.9 0 1 1 1.8 0v13.827l3.964-3.963a.9.9 0 0 1 1.272 1.272l-5.5 5.5A.9.9 0 0 1 12 20.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["arrow-down"],
  category: "utility" as const,
};
